import React, { useEffect, useMemo } from 'react';
import { Route } from '../../../linerServiceAdminRoute';
import BaseTable, { IBaseTableData, IBaseTableRow } from '../../../table/baseTable';
import { TypeaheadSearchResultItem } from '../../../typeaheadSearchResult';

import { LocationData } from '../../map.interfaces';
import { useTranslation } from 'react-i18next';

export interface IMapPopupProps {
  locationData: LocationData;
}

export interface IProperyElement {
  property: string;
  locationData: LocationData;
}

const TableHeader = (headerText: string, className?: string) => <span className={className}>{headerText}</span>;
const RowColumn = (columnText: string, linkUrl?: string) =>
  linkUrl ? (
    <a href={linkUrl} target={linkUrl.startsWith('http') ? '_blank' : '_self'} className="liner-popup-table-col link">
      <div>{columnText}</div>
    </a>
  ) : (
    <div className="liner-popup-table-col">{columnText}</div>
  );

const LinerServicesPopup = ({ locationData }: IMapPopupProps) => {
  const { t } = useTranslation();

  const getCargoText = (route: Route) => {
    if (route.roro && !route.container) {
      return t('linermap.roroVehicle');
    }

    if (!route.roro && route.container) {
      return t('linermap.container');
    }

    if (route.roro && route.container) {
      return t('linermap.roroVehicle') + ', ' + t('linermap.container');
    }

    return '-';
  };

  const tableData = useMemo(() => {
    const baseData: IBaseTableData = {
      headers: [
        { id: 1, headerData: TableHeader(t('linermap.agent'), 'liner-popup-table-header'), columnId: 1 },
        { id: 2, headerData: TableHeader(t('linermap.shippingcompany'), 'liner-popup-table-header'), columnId: 2, maxWidth: 120 },
        { id: 3, headerData: TableHeader(t('linermap.frequency'), 'liner-popup-table-header'), columnId: 3, maxWidth: 100 },
        { id: 4, headerData: TableHeader(t('linermap.terminal'), 'liner-popup-table-header'), columnId: 4 },
        { id: 5, headerData: TableHeader(t('linermap.cargo'), 'liner-popup-table-header'), columnId: 5 },
      ],
      rows: [],
    };
    if (locationData?.propertyData?.routes) {
      const routes: Route[] = JSON.parse(locationData?.propertyData?.routes) as Route[];

      if (routes) {
        routes.forEach((route, index) => {
          const rowData: IBaseTableRow = {
            id: index,
            columns: [
              {
                id: 1,
                columnData: RowColumn(route.agent?.label || '', route?.agent?.link),
                filterValue: route.agent?.label,
              },
              {
                id: 2,
                columnData: RowColumn(route?.shippingCompany?.label || '', route?.shippingCompany?.link),
                filterValue: route?.shippingCompany?.label,
                maxWidth: 120,
              },
              {
                id: 3,
                columnData: RowColumn(route?.routeFrequency?.label || ''),
                filterValue: route?.routeFrequency?.label,
                maxWidth: 100,
              },
              {
                id: 4,
                columnData: RowColumn(route?.terminal?.label || '', route?.terminal?.link),
                filterValue: route?.terminal?.label,
              },
              {
                id: 5,
                columnData: RowColumn(getCargoText(route)),
                filterValue: getCargoText(route),
              },
            ],
            expandedAtStart: false,
          };

          baseData?.rows.push(rowData);
        });
      }
    }
    return baseData;
  }, [locationData]);

  return (
    <div className="map-popup-liner-services">
      <h4 className="city-name">{locationData.propertyData.name_en}</h4>
      <BaseTable data={tableData} />
    </div>
  );
};

export default LinerServicesPopup;
